document.addEventListener("click", function (event) {
  if (event.target.matches(".notify-me")) {
    event.preventDefault();
    const productName = event.target.getAttribute("data-product-title");
    document.getElementById("product_name").textContent = productName;
    document.getElementById("notify-me--popup").style.display = "flex";
    document.body.classList.add('overflow-hidden');
  }
});

document.addEventListener("input", function (event) {
  if (event.target.id === "notifyMobile") {
    const phoneNumber = event.target.value;
    const hiddenInput = document.querySelector('input[name="contact[tags]"]');
    const productName = document.getElementById("product_name").textContent;
    hiddenInput.value = `Notify Me_${phoneNumber}_${productName}`;
  }
});

const notifySubmitButton = document.querySelector(".notify-me--submit-button");
const notifyForm = document.querySelector("#notify-me--popup #contact_form");

if (notifySubmitButton) {
  notifySubmitButton.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the form from submitting immediately

    const notifyEmail = notifyForm.querySelector("#notifyEmail").value;
    const notifyPhone = notifyForm.querySelector("#notifyMobile").value;
    const checkConsent = notifyForm.querySelector("#notifyCheckbox").checked;

    const header_value = {
      isoLanguage: "EN",
      isoCountry: "IN",
      brandCode: "BH8702",
      campaignId: "PN002392",
      campaignDescription: "Always On",
      origin: "https://lovebeautyandplanet.in/",
      formType: "signUp",
      entity: "PRM2.6",
    };

    const x_api_key = "665fb793-eb8d-42ed-85e7-31981ee4ac1a";

    const consumerIdentity = {
      firstName: "N/A",
      lastName: "N/A",
    };

    const contactDetail = {
      email: notifyEmail,
      mobileNumber: `+91${notifyPhone}`,
    };

    const optInStatus = {
      legalAgeConsent: checkConsent,
      unileverEmailConsent: checkConsent,
      unileverSMSConsent: checkConsent,
    };

    const data_value = JSON.stringify({
      profile: {
        header: header_value,
        consumerIdentity,
        contactDetail,
        optInStatus,
      },
    });

    if (checkConsent == true) {
      fetch("https://forms-sg.unileversolutions.com/v3", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": x_api_key,
        },
        body: data_value,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("Success:", data);
          // If the API call is successful, submit the form to Shopify
          notifyForm.submit();
        })
        .catch((error) => {
          console.error("Error:", error);
          // alert("Failed to submit the form. Please try again.");
          notifyForm.submit();
        });
    }
    else {
      notifyForm.submit();
    }
  });
}

function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function validatePhone(phone) {
  const phoneRegex = /^[9876]\d{9}$/;
  return phoneRegex.test(phone);
}

function submitNotification() {
  const emailField = document.getElementById("notifyEmail");
  const phoneField = document.getElementById("notifyMobile");
  const consentCheckbox = document.getElementById("notifyCheckbox");

  const errorEmail = document.getElementById("errorEmail");
  const errorMobile = document.getElementById("errorMobile");

  const email = emailField.value.trim();
  const phone = phoneField.value.trim();

  const notifyMeForm = document.querySelector(".notify-me-form");
  // const notifyFormTags = document.querySelector('[name="contact[tags]"]');
  // notifyFormTags.value = `Notify Me_${phoneField.value}`;

  let isValid = true;

  // Validate email id
  if (!validateEmail(email)) {
    errorEmail.innerHTML = `<svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
          </path>
        </svg>Please enter a valid email address`;
    isValid = false;
  }

  // Validate phone number
  if (!validatePhone(phone)) {
    errorMobile.innerHTML = `<svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
          </path>
        </svg>
      Please enter a valid mobile number`;
    isValid = false;
  }

  // If all validations pass
  if (isValid) {
    notifyMeForm.submit();
    const notifyPopup = document.getElementById("notify-me--popup");
    notifyPopup.style.display = "none";

    const successPopup = document.querySelector(".notify-me--success-message");
    successPopup.style.display = "flex";

    emailField.value = "";
    phoneField.value = "";
    consentCheckbox.checked = false;

    setTimeout(() => {
      successPopup.style.display = "none";
    }, 5000);
  }
}

function closePopup() {
  const popup = document.getElementById("notify-me--popup");
  popup.style.display = "none";
  document.body.classList.remove('overflow-hidden');
  resetErrorMessages();
}

function closeSuccessPopup() {
  const successPop = document.getElementById("notify-me--success-message");
  successPop.style.display = "none";
}

function resetErrorMessages() {
  const emailField = document.getElementById("notifyEmail");
  const phoneField = document.getElementById("notifyMobile");
  const consentCheckbox = document.getElementById("notifyCheckbox");

  if (errorEmail) errorEmail.innerHTML = "";
  if (errorMobile) errorMobile.innerHTML = "";

  if (emailField) emailField.value = "";
  if (phoneField) phoneField.value = "";
  if (consentCheckbox) consentCheckbox.checked = false;
}

// Privacy pop-up code
var modal = document.getElementById("mainRegisterModal");
var modalBody = document.getElementById("mainRegisterModalBody");
var closeButton = document.getElementsByClassName(
  "main-register--close-button"
)[0];
var privacyContent = document.getElementById("privacy-content").innerHTML;

document.getElementById("privacyPopUp").onclick = function () {
  document.body.classList.add("overflow-hidden");
  loadContent(privacyContent);
};

function loadContent(content) {
  modal.style.display = "block";
  modalBody.innerHTML = content;
}

closeButton.onclick = function () {
  document.body.classList.remove("overflow-hidden");
  modal.style.display = "none";
};
